import React, { useRef, useState, useEffect } from "react";
import { UploadCourseFile } from "./UploadCourseFile";
import FileViewer from "react-file-viewer";
import "./courseImg.css";

const CourseFile = ({
  courseFileLimit,
  courseFile,
  prevFiles,
  courseId,
  isCurrentFileUploadStatus,
  isCurrentFileUpload,
  removeType = null,
}) => {
  const fileInputRef = useRef();
  const courseVidRef = useRef();

  const [selectedFiles, setSelectedFiles] = useState(
    prevFiles ? prevFiles : []
  );
  const [validFiles, setValidFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [showCourseImage, setShowCourseImage] = useState(false);
  const [currentFile, setCurrentFile] = useState("");
  const [fileType, setFileType] = useState("");
  const [filePath, setFilePath] = useState("");
  const [showUploaded, setShowUploaded] = useState(false);
  const [showCourseVideo, setShowCourseVideo] = useState(false);
  const [video, setVideo] = useState();
  const [playPreview, setPlayPreview] = useState(true);
  const [test, setTest] = useState();
  const [modalImage, setModalImage] = useState();
  const [courseImage, setCourseImage] = useState(false);

  useEffect(() => {
    if (selectedFiles && selectedFiles.length > 0) {
      let filteredArr = selectedFiles.reduce((file, current) => {
        const x = file.find((item) => item.name === current.name);
        if (!x) {
          return file.concat([current]);
        } else {
          return file;
        }
      }, []);
      if (filteredArr.length > 0) {
        setValidFiles([...filteredArr]);
      }
    }
  }, [selectedFiles]);

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const dragOver = (e) => {
    preventDefault(e);
  };

  const dragEnter = (e) => {
    preventDefault(e);
  };

  const dragLeave = (e) => {
    preventDefault(e);
  };

  const fileDrop = (e) => {
    preventDefault(e);
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
    }
  };

  const filesSelected = () => {
    if (fileInputRef.current.files.length) {
      handleFiles(fileInputRef.current.files);
    }
  };

  const fileInputClicked = () => {
    fileInputRef.current.click();
  };

  const handleFiles = (files) => {
    for (
      let i = 0;
      i < files.length && selectedFiles.length < courseFileLimit;
      i++
    ) {
      if (validateFile(files[i])) {
        setSelectedFiles((prevArray) => [...prevArray, files[i]]);
      } else {
        files[i]["invalid"] = true;
        setSelectedFiles((prevArray) => [...prevArray, files[i]]);
        setErrorMessage(
          "Sorry, that file type is not permitted. Please use XLR, XLS, XLSX, TXT, PDF, PPTX, PPT, DOCX, DOC, or CSV"
        );
      }
    }
  };

  const validateFile = (file) => {
    const validTypes = [
      "application/pdf",
      "application/x-zip-compressed",
      "application/msword",
      "application/vnd.ms-excel",
      "application/vnd.ms-powerpoint",
      "application/ppt",
      "application/pptx",
      "text/plain",
      "text/csv",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "video/mp4",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    if (validTypes.indexOf(file.type) === -1) {
      return false;
    }

    return true;
  };
  const imageType = ["jpeg", "jpg", "png", "gif", "webp"];

  const filesupported = (fileName) => {
    const supportedFileTypes = ["pdf", "csv", "xlsx", "docx", "ppt", "pptx"];

    if (
      supportedFileTypes.indexOf(
        fileName.substr(fileName.lastIndexOf(".") + 1)
      ) == -1
    )
      return false;
    else return true;
  };

  const downloadFile = (file) => {
    if (!file.invalid) {
      let urldata = window.URL.createObjectURL(file);
      let aTag = document.createElement("a");
      aTag.href = urldata;
      aTag.download = file.name;
      aTag.click();
      aTag.remove();
    }
  };

  const removeFile = (name) => {
    const index = validFiles.findIndex((e) => e.name === name);
    const index2 = selectedFiles.findIndex((e) => e.name === name);
    validFiles.splice(index, 1);
    selectedFiles.splice(index2, 1);
    setValidFiles([...validFiles]);
    setSelectedFiles([...selectedFiles]);
    if (!removeType) {
      courseFile(selectedFiles);
    }
    closeModal();
    fileInputRef.current.value = "";
    setShowUploaded(false);
    setShowCourseImage(false);
    setShowCourseVideo(false);
    setCourseImage(false);
  };

  const openImageModal = (file) => {
    if (!file.invalid && filesupported(file.name)) {
      const reader = new FileReader();

      reader.onload = function (e) {
        let fileName = file.name;
        setFileType(fileName.substr(fileName.lastIndexOf(".") + 1));
        setFilePath(e.target.result);
        setCurrentFile(file);
        setShowCourseImage(true);
      };

      reader.readAsDataURL(file);
    } else {
      let fileName = file.name;
      setTest(fileName);

      const reader = new FileReader();
      reader.readAsDataURL(file);
      setShowCourseVideo(false);
      setCourseImage(false);

      reader.onload = function (e) {
        setFileType(fileName.substr(fileName.lastIndexOf(".") + 1));
        const extension = fileName.split(".").pop();

        if (imageType.includes(extension)) {
          setModalImage(e.target.result);
          setCourseImage(true);
        } else if (extension != "zip") {
          setVideo(e.target.result);
          setShowCourseVideo(true);
        }
      };
    }
  };

  const closeModal = () => {
    setShowCourseImage(false);
    // modalImageRef.current.style.backgroundImage = "none";
  };

  const uploadedDocument = () => {
    setShowUploaded(!showUploaded);
  };

  const close = () => {
    setShowUploaded(false);
  };

  const handleDeleteVideo = () => {
    const name = test;
    const index = validFiles.findIndex((e) => e.name === name);
    const index2 = selectedFiles.findIndex((e) => e.name === name);
    validFiles.splice(index, 1);
    selectedFiles.splice(index2, 1);
    setValidFiles([...validFiles]);
    setSelectedFiles([...selectedFiles]);
    courseFile(selectedFiles);
    closeModal();
    fileInputRef.current.value = "";
    setShowCourseVideo(false);
    setCourseImage(false);
  };

  const handlePlayVideo = (e) => {
    preventDefault(e);
    setPlayPreview(!playPreview);
    if (courseVidRef.current.paused) {
      courseVidRef.current.play();
    } else {
      courseVidRef.current.pause();
    }
  };

  const truncate = (str) => {
    return str.length > 10 ? str.substring(0, 30) + "..." : str;
  };

  const setFormState =
    (files, index) =>
    ({ uploadId }) => {
      const prevFiles = [...files];
      prevFiles[index].uploadId = uploadId;
      prevFiles[index].isNewFile = true;
      courseFile(prevFiles);
    };
  return (
    <>
      <div className="course_main">
        <h3 className="course_heading">Upload your first course file</h3>
        <br />
        <h5 className="course_image-drop-text">
          The accepted file formats are XLR, XLS, XLSX, TXT, PDF, PPTX, PPT,
          DOCX, DOC ,CSV ,ZIP
        </h5>
        <div>
          <div
            className="course_image-drop-container"
            onDragOver={dragOver}
            onDragEnter={dragEnter}
            onDragLeave={dragLeave}
            onDrop={fileDrop}
            onClick={fileInputClicked}
          >
            <div className="course_drop-message">
              <div className="course_upload-icon"></div>
              <span className="course_image-drop-text">
                Drag and drop or browse to choose a file
              </span>
            </div>
            <input
              ref={fileInputRef}
              className="course_file-input"
              type="file"
              onChange={filesSelected}
              accept="application/pdf,              
              application/msword,
              application/vnd.ms-excel,
              application/vnd.ms-powerpoint,
              application/pptx,
              application/ppt
              text/plain,
              text/csv,
              zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed,
              application/vnd.openxmlformats-officedocument.wordprocessingml.document,
              application/vnd.openxmlformats-officedocument.presentationml.presentation,
              application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
              video/mp4,
                 image/jpeg,
      image/jpg,
      image/png,
      image/gif,
      image/webp"
            />
          </div>
          <div>
            {validFiles.map((data, i) => {
              return (
                <div key={i}>
                  <UploadCourseFile
                    file={data}
                    courseId={courseId}
                    openPreviewModal={() => openImageModal(data)}
                    removeFile={() => removeFile(data.name)}
                    storageType={
                      data?.type === "application/x-zip-compressed"
                        ? "CourseScrom"
                        : "CourseSectionFiles"
                    }
                    setFormState={setFormState(validFiles, i)}
                    isCurrentFileUpload={isCurrentFileUpload}
                    isCurrentFileUploadStatus={isCurrentFileUploadStatus}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {showCourseImage && (
        <div className="modal fade" role="dialog">
          <div className="course_modal-dialog modal-lg">
            <div className="course_modal-content file-viewer-content">
              <div className="course_modal-header">
                <button
                  type="button"
                  onClick={closeModal}
                  className="btn next close-file"
                  data-dismiss="modal"
                >
                  Close
                </button>

                <button
                  type="button"
                  onClick={() => downloadFile(currentFile)}
                  className="btn next"
                  data-dismiss="modal"
                >
                  Download
                </button>

                <h4 className="course_modal-title" id="myModalLabel">
                  Course File
                </h4>
              </div>
              <div className="course_modal-body file-viewer-body">
                <FileViewer fileType={fileType} filePath={filePath} />
              </div>
              {/* <div className="course_modal-footer"></div> */}
            </div>
          </div>
        </div>
      )}

      {showCourseVideo && (
        <div className="course_modal-dialog">
          <div className="course_modal-content">
            <div className="course_modal-body">
              <div className="align-image">
                <ul>
                  <li>
                    <img
                      src="https://cdn.edusity.com/icons/icon-refresh.svg"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      onClick={handleDeleteVideo}
                      src="https://cdn.edusity.com/icons/icon-trash.svg"
                      alt=""
                    />
                  </li>
                </ul>
              </div>

              <div className="preview-thumbnail" onClick={handlePlayVideo}>
                {playPreview === true && (
                  <div className="preview-inner">
                    <div className="play-icon-contanier">
                      <img
                        className="play-icon"
                        src="https://cdn.edusity.com/edusityUI/icons/icon_video_play.svg"
                        alt="play-button"
                      />
                    </div>
                  </div>
                )}
                <video id="refVid" ref={courseVidRef} controls={true}>
                  <source src={video} type="video/mp4"></source>
                </video>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Image preview */}
      {courseImage && (
        <div className="course_modal-body">
          <div className="align-image">
            <ul>
              <li>
                <img
                  src="https://cdn.edusity.com/icons/icon-refresh.svg"
                  alt=""
                />
              </li>
              <li>
                <img
                  onClick={handleDeleteVideo}
                  src="https://cdn.edusity.com/icons/icon-trash.svg"
                  alt=""
                />
              </li>
            </ul>
          </div>

          <img id="fileframe" src={modalImage} width="540px" height="324px" />
        </div>
      )}

      {showUploaded && (
        <div className="modal fade" role="dialog">
          <div className="course_modal-dialog modal-lg">
            <div className="course_modal-content file-viewer-content">
              <div className="course_modal-header">
                <button
                  type="button"
                  onClick={close}
                  className="btn next close-file"
                  data-dismiss="modal"
                >
                  Close
                </button>

                <h4 className="course_modal-title" id="myModalLabel">
                  Course File
                </h4>
              </div>
              <div className="course_modal-body file-viewer-body">
                {/* <FileViewer fileType="pdf" filePath={data} /> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CourseFile;
